import SuggestedQuestions from './SuggestedQuestions';

export default SuggestedQuestions;
